import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { store } from './store';
// Removed static theme provider and use dynamic ThemeModeProvider
import { ThemeModeProvider } from './ThemeModeContext';

// Layouts
import PublisherLayout from './layouts/PublisherLayout';
import PublicLayout from './layouts/PublicLayout';

// Pages
import Home from './pages/Home';
import PublishersPage from './pages/PublishersPage';
import WebsitesPage from './pages/WebsitesPage';
import JournalistsPage from './pages/JournalistsPage';
import NotFound from './pages/NotFound';
import PublisherDetailPage from './pages/PublisherDetailPage';
import ListenerPreviewPage from './pages/ListenerPreviewPage';
import AdvertisersPage from './pages/AdvertisersPage';
import MusiciansPage from './pages/Musicians';
import IssueCastsPage from './pages/IssueCasts';

// Fonts
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/lexend/400.css';
import '@fontsource/lexend/500.css';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <ThemeModeProvider>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
          <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
              {/* Public Routes */}
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
              </Route>
              
              {/* Publisher Routes (Protected) */}
              <Route element={<PublisherLayout />}>
                <Route path="/publishers" element={<PublishersPage />} />
                <Route path="/publishers/:id" element={<PublisherDetailPage />} />
                <Route path="/websites" element={<WebsitesPage />} />
                <Route path="/journalists" element={<JournalistsPage />} />
                <Route path="/advertisers" element={<AdvertisersPage />} />
                <Route path="/podcasts" element={<IssueCastsPage />} />
                <Route path="/musicians" element={<MusiciansPage />} />
                <Route path="/listener-experience" element={<ListenerPreviewPage />} />
                {/* Add more publisher routes here */}
              </Route>
              
              {/* 404 Route */}
              <Route path="/404" element={<NotFound />} />
              
              {/* Redirect any unknown routes to 404 */}
              <Route path="*" element={<Navigate to="/404" replace />} />
            </Routes>
          </Router>
        </GoogleOAuthProvider>
      </ThemeModeProvider>
    </Provider>
  );
};

export default App;